// src/pages/dashboard/TalentDashboardLayout.js

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HeaderComponent from '../../../components/HeaderComponent';

import DirectorDashboard from './DirectorDashboard';
import DirectorProfilePage from './DirectorProfilePage'; 
import ManageProjectsPage from '../../projects/ManageProjectsPage';
import PostProjectsPage from '../../projects/PostProjectsPage';
import ManageRolesPage from '../../roles/ManageRolesPage';
import PostRolesPage from '../../roles/AddEditRolePage';
import TransactionHistoryPage from '../TransactionHistoryPage';
import ChangePasswordPage from '../ChangePasswordPage'; 
import ManageApplicationsPage from './ManageApplicationsPage';
import ManageApplicationList from '../../roles/ManageApplicationList'; 
import ManageApplicationDetails from '../../roles/ManageApplicationDetails';
import DirectorSidebar from './DirectorSidebar';

import './DirectorProducerDashboardLayout.css'; 
import FooterComponent from '../../../components/FooterComponent';

const DirectorProducerDashboardLayout = () => {
    return (
         <div className="dir-dashboard-layout min-vh-100 flex flex-column">
            <HeaderComponent />

         
            <div className="dashboard-body flex flex-grow-1">
                <DirectorSidebar/> 
                <main className="dashboard-main-content flex-grow-1 overflow-y-auto py-4">
                    <Routes>
                        <Route index element={<Navigate to="overview" replace />} /> 
                        <Route path="overview" element={<DirectorDashboard />} />
                        <Route path="profile" element={<DirectorProfilePage />} />
                        <Route path="projects" element={<ManageProjectsPage />} />
                        <Route path="post-projects" element={<PostProjectsPage />} />
                        <Route path="post-projects/:projectId" element={<PostProjectsPage />} /> 
                        <Route path="roles" element={<ManageRolesPage />} />
                        <Route path="post-roles" element={<PostRolesPage />} />
                        <Route path="post-roles/:id" element={<PostRolesPage />} /> 
                        <Route path="ChangePasswordPage" element={<ChangePasswordPage />} />
                        <Route path="transaction-history" element={<TransactionHistoryPage />} />
                        <Route path="manage-applications" element={<ManageApplicationList />} />
                        <Route path="manage-applications/:id" element={<ManageApplicationDetails />} />
                        
                    </Routes>
                </main>
            </div>
             <FooterComponent />
        </div>
    );
};

export default DirectorProducerDashboardLayout;